module.exports = __webpack_public_path__ + "img/icon-coin.a3b93c31.svg";